import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import ruby from '../assets/ruby.png';
import postgres from '../assets/postgres.png';
import rails from '../assets/rails.png';
import clog3 from '../assets/clog3.png';
import kidist from '../assets/kidist.JPG';
import collins from '../assets/collins.png';
import yomie from '../assets/yomie.PNG';
import moriasi from '../assets/moriasi.JPG';
import joe from '../assets/joe.JPG';
import reggie from '../assets/reggie.JPG';
import tarek from '../assets/tarek.JPG';
import shakes from '../assets/shakes.svg';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import default1 from '../assets/default1.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';
import vscode from '../assets/vscode.png';
import github from '../assets/github.png';
import npm from '../assets/npm.png';
import jest from '../assets/jest.png';
import rspec from '../assets/rspec.png';
import chromedev from '../assets/chromedev.png';
import webpack from '../assets/webpack.png';
import postman from '../assets/postman.png';
import slack from '../assets/slack.png';
import googlemeet from '../assets/googlemeet.png';
import zoom from '../assets/zoom.avif';

import space from '../assets/space.png';
import paradise from '../assets/paradise.png';
import talantaF from '../assets/talantaF.png';
import portfolio from '../assets/portfolio.png';

export default {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  rails,
  ruby,
  postgres,
  clog3,
  kidist,
  yomie,
  joe,
  reggie,
  tarek,
  moriasi,
  collins,
  about01,
  about02,
  about03,
  about04,
  profile,
  default1,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  github,
  postman,
  npm,
  rspec,
  jest,
  vscode,
  chromedev,
  webpack,
  slack,
  googlemeet,
  zoom,
  space,
  paradise,
  talantaF,
  portfolio,
  shakes,
};
